import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,{staticClass:"ma-0 elevation-1",attrs:{"src":_vm.iconUrl(),"max-width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }